import { render } from "./AppSidebarComponent.vue?vue&type=template&id=48c45a89&scoped=true"
import script from "./AppSidebarComponent.vue?vue&type=script&lang=js"
export * from "./AppSidebarComponent.vue?vue&type=script&lang=js"

import "./AppSidebarComponent.vue?vue&type=style&index=0&id=48c45a89&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48c45a89"]])

export default __exports__